import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import OfferCardCarousel from '../../../components/OfferCardCarousel'
import buildImageUrl from '../../../../lib/media-url-maker'

const UnmissableSpecialOffersWidget = (props) => {
  return <OfferCardCarousel offers={props.data} />
}

const UnmissableSpecialOffers = (props) => {
  const offerIds = props.offers
  const data = useStaticQuery(graphql`
    query {
      allOfferCatfish(filter: { state: { eq: "Published" } }) {
        edges {
          node {
            id: _id
            sell
            model {
              _id
            }
            make {
              name
            }
            callToActionLink
            slug
            heading
            subheading
            images
            callOut
            details
            usedVehicle {
              _id
              brand
              model
              derivative
              registration
              value
              year
              hpFinance {
                monthlyPayment
              }
              pcpFinance {
                monthlyPayment
              }
            }
          }
        }
      }
    }
  `)

  const filteredOffers =
    data &&
    data.allOfferCatfish &&
    data.allOfferCatfish.edges &&
    data.allOfferCatfish.edges.length >= 0 &&
    data.allOfferCatfish.edges
      .filter((data) => offerIds.includes(data.node.id))
      .map((data) => {
        const offer = data.node
        const image = buildImageUrl({
          width: 1600,
          resource: offer.images && offer.images[0]
        })
        const usedVehicle = offer.usedVehicle && offer.usedVehicle[0]

        let url = ''

        if (
          offer.callToActionLink &&
          (offer.callToActionLink.startsWith('/') ||
            offer.callToActionLink.startsWith('http'))
        ) {
          url = offer.callToActionLink
        } else if (offer.callToActionLink) {
          url = '/' + offer.callToActionLink
        } else if (offer.slug) {
          url = offer.slug
        } else if (usedVehicle) {
          url = `/cars/used/${usedVehicle.brand}/${usedVehicle.model}/${usedVehicle.registration}`
        } else {
          url = '/'
        }

        let result = { ...offer, href: url, image, label: offer.callOut }

        if (usedVehicle) {
          result = {
            ...result,
            currency: {
              symbol: '£'
            },
            price: {
              total: usedVehicle.value,
              installment: {
                payment:
                  usedVehicle.pcpFinance &&
                  usedVehicle.pcpFinance.monthlyPayment,
                plan: 'Month',
                type: 'PCP'
              }
            },
            registrationNumber: usedVehicle.registration
          }
        }

        return result
      })

  if (!filteredOffers || !filteredOffers.length) return null

  return <UnmissableSpecialOffersWidget data={filteredOffers} {...props} />
}

export default UnmissableSpecialOffers
